import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, TextField } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers/icons";
import { useEffect, useState } from "react";

interface EditIndoorDialogProps {
    onClose: (name: string | null, identifier: string | null) => void,
    open: boolean,
    title: string,
    defaultName?: string,
    defaultIdentifier?: string | null,
    cancelText?: string,
    enterText?: string,
}

const EditIndoorDialog = (props: EditIndoorDialogProps) => {
    const { onClose, open, title, defaultName, defaultIdentifier, cancelText, enterText } = props;
    const [name, setName] = useState<string>(defaultName ?? "");
    const [identifier, setIdentifier] = useState<string>(defaultIdentifier ?? "");

    useEffect(() => {
        if (open) {
            setName(defaultName ?? "");
            setIdentifier(defaultIdentifier ?? "");
        }
    }, [open, defaultName, defaultIdentifier]);

    const handleEnterText = () => {

        const identifierTrim = identifier.trim();

        onClose(name.trim(), identifierTrim === "" ? null : identifierTrim);
    };

    const handleCancelPressed = () => {
        onClose(null, null);
    };

    const handleIdentifierChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const lower = e.target.value.toLowerCase();
        setIdentifier(lower);
    };

    return (
        <Dialog fullWidth maxWidth="xs" open={open}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="value"
                    value={name}
                    label="Experience Name"
                    onChange={(e) => setName(e.target.value)}
                    type="text"
                    fullWidth
                    variant="standard"
                />
                <TextField
                    margin="dense"
                    label="Identifier"
                    value={identifier}
                    onChange={handleIdentifierChange}
                    fullWidth
                    variant="standard"
                    InputProps={{
                        endAdornment: identifier ? (
                            <InputAdornment position="end">
                                <IconButton
                                    size="small"
                                    onClick={() => setIdentifier("")}
                                >
                                    <ClearIcon fontSize="small" />
                                </IconButton>
                            </InputAdornment>
                        ) : null
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleCancelPressed}>{cancelText || "Cancel"}</Button>
                <Button variant="contained" color="primary" onClick={handleEnterText}>{enterText || "Enter"}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditIndoorDialog;